import React from 'react'
import propTypes from 'prop-types'
import { CashflowEventsProvider } from './context'
import { CashflowEventsScreens } from './CashflowEventsScreens'

import { Card } from '../../components/layout/Card'
import { Header } from './components/Header'

export const CashflowEvents = (props) => {
  return (
    <CashflowEventsProvider {...props}>
      <Card className='ui-card--cashflow-events'>
        <Header />
        <CashflowEventsScreens />
      </Card>
    </CashflowEventsProvider>
  )
}

CashflowEvents.propTypes = {
  scenario: propTypes.shape({
    id: propTypes.number,
    expectedAge: propTypes.number,
  }),
  cashflowEvents: propTypes.array.isRequired,
  crudActions: propTypes.object,
  saygScenariosEnabled: propTypes.bool,
  riskProfile: propTypes.object,
  assumptions: propTypes.object,
  userDetails: propTypes.object.isRequired,

  //Joint plan specific props
  participants: propTypes.array,
}
